import type { IconProps } from '../types/IconProps.ts';
export const BrainCircuit: IconProps = {
    name: 'BrainCircuit',
    children: [
        `<path d="M7 4c.27-1.17 1.3-2 2.5-2h1.59c.5 0 .91.4.91.91V21.1c0 .5-.4.91-.91.91H9.5c-1.2 0-2.24-.83-2.51-2" />`,
        `<path d="M17 4c-.27-1.17-1.3-2-2.5-2h-1.6a.9.9 0 0 0-.91.91V21.1c0 .5.4.91.91.91h1.58c1.2 0 2.24-.83 2.51-2M5 15a3 3 0 1 1 0-6M19 15a3 3 0 1 0 0-6" />`,
        `<path d="M12 12v5a4 4 0 0 0 4-4v-1M16 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M9 12h3M9 17c0 1.1.9 2 2 2h1v-2M15 7a1 1 0 0 0-1-1h-2v1M19 15c.67 1.33 1.2 4.2-2 5M17 4c1.33.33 3.6 1.8 2 5M7 4c-1.33.33-3.6 1.8-2 5M5 15c-.67 1.33-1.2 4.2 2 5" />`,
    ]
};